import { connect } from 'react-redux';

import { getAllSecondHandBoardgames, markBoardgameAsSold } from '../actions/secondHandBoardgames';

import { allBoardgamesSelector } from '../reducers/secondHandBoardgames';

import AdminSecondHandBoardgamesListPageComponent from '../components/AdminSecondHandBoardgamesListPage';

const mapStateToProps = state => {
  return {
    boardgames: allBoardgamesSelector(state),
  };
};

const mapDispatchToProps = dispatch => {
  return { 
    getAllBoardgames: () => dispatch(getAllSecondHandBoardgames()),
    markBoardgameAsSold: (bg, sold) => dispatch(markBoardgameAsSold(bg, sold)),
  };
};

const AdminSecondHandBoardgamesListPage = connect(mapStateToProps, mapDispatchToProps)(AdminSecondHandBoardgamesListPageComponent);

export default AdminSecondHandBoardgamesListPage;
